<template>
	<div class="l-edit-dialog-box">
		<el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left" v-loading="loading">
			<el-form-item label="上级菜单" prop="pid">
				<el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
			</el-form-item>
			<el-form-item label="菜单名称" prop="menu_name">
				<el-input v-model="form_data.menu_name" autocomplete="off" placeholder="请输入菜单名称"></el-input>
			</el-form-item>
			<el-form-item label="是否节点" prop="is_node">
				<el-radio-group v-model="form_data.is_node">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="图标" prop="icon" v-if="form_data.is_node == 1">
				<el-input v-model="form_data.icon" autocomplete="off" placeholder="请输入图标"></el-input>
			</el-form-item>
			<el-form-item label="路由" prop="route" v-if="form_data.is_node == 0">
				<el-input v-model="form_data.route" autocomplete="off" placeholder="请输入路由"></el-input>
			</el-form-item>
			<el-form-item label="是否公共" prop="is_public">
				<el-radio-group v-model="form_data.is_public">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="状态" prop="state">
				<el-radio-group v-model="form_data.state">
					<el-radio :label="1">启用</el-radio>
					<el-radio :label="0">禁用</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="排序" prop="sort_num">
				<el-input type="number" v-model.number="form_data.sort_num" autocomplete="off" placeholder="请输入排序"></el-input>
			</el-form-item>
		</el-form>
		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: "l-menu-edit",
	props: {
		id: {
			type: [String, Number],
			default: null,
		},
		pid: {
			type: [String, Number],
			default: "",
		},
		visible: {
			type: Boolean,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false, //页面是否加载中
			tree_node: [],
			//表单数据
			form_data: {
				pid: [],
				menu_name: "",
				is_node: 1,
				route: "",
				is_public: 0,
				state: 1,
				sort_num: 0,
				icon: "",
				module_ids: [],
			},
			//表单验证规则
			rules: {
				pid: [{ type: "array", required: true, message: "请选择上级节点", trigger: "change" }],
				menu_name: [{ required: true, message: "菜单名称不能为空", trigger: "change" }],
				is_node: [{ type: "number", required: true, message: "请选择是否节点", trigger: "change" }],
				route: [{ required: true, message: "路由不能为空", trigger: "change" }],
				sort_num: [{ type: "number", required: true, message: "排序不能为空", trigger: "change" }],
				is_public: [{ type: "number", required: true, message: "请选择是否公共", trigger: "change" }],
				state: [{ type: "number", required: true, message: "请选择状态", trigger: "change" }],
				icon: [{ required: true, message: "请输入图标", trigger: "change" }],
			},
			//提交按钮是否显示加载中
			submitting: false,
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getData();
				}
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},
		//获取数据
		getData() {
			if (this.hasId) {
				this.loading = true;
				this.$_invoke(`menu_getEditData`, { id: this.$props.id })
					.then((ret) => {
						let { tree_node, list, data } = ret;
						this.tree_node = tree_node;
						this.$nextTick(() => {
							//找到pid所属的路径
							const curr_p_data = list.find((item) => {
								return item.id == data.pid;
							});
							let p_path_arr = curr_p_data.path.split(">");
							p_path_arr = p_path_arr.filter((item) => {
								return item != "";
							});
							p_path_arr.push(data.pid);
							p_path_arr = p_path_arr.map((item) => {
								return parseInt(item);
							});
							p_path_arr.splice(0, 1);
							data.pid = p_path_arr;
							this.form_data = data;
						});
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.loading = true;
				this.$_invoke(`menu_getAddData`)
					.then((ret) => {
						const { list, tree_node } = ret;
						this.tree_node = tree_node;
						this.$nextTick(() => {
							if (this.$props.pid) {
								//找到pid所属的路径
								const curr_p_data = list.find((item) => {
									return item.id == this.$props.pid;
								});
								let p_path_arr = curr_p_data.path.split(">");
								p_path_arr = p_path_arr.filter((item) => {
									return item != "";
								});
								p_path_arr.push(this.$props.pid);
								p_path_arr = p_path_arr.map((item) => {
									return parseInt(item);
								});
								p_path_arr.splice(0, 1);
								this.form_data.pid = p_path_arr;
							}
						});
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					let form_data = Object.assign({}, this.form_data);
					const pid_len = form_data.pid.length;
					form_data.pid = form_data.pid[pid_len - 1];
					if (!this.hasId) {
						//添加
						this.$_invoke("menu_save", form_data)
							.then(() => {
								this.$_msg.success("添加成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					} else {
						//修改
						this.$_invoke(`menu_update`, form_data)
							.then(() => {
								this.$_msg.success("修改成功");
								this.$emit("on-success");
							})
							.finally(() => {
								this.submitting = false;
							});
					}
				}
			});
		},
	},
};
</script>
